// Shared by the Retention Pipeline's Renewal Window cards (and the outcome modal). Moved here
// verbatim from RenewalRemindersPanel.jsx when that page was retired (10/6/26) so the approved
// renewal script wording lives in exactly one place. Wording is BK's deliberate retention nudge
// (see docs/COMS_Renewal_Reminders_Build_Spec.md) — change it only on purpose.

export function firstName(memberName) {
  if (!memberName) return 'there';
  return memberName.split(' ')[0];
}

export function formatDate(iso) {
  return new Date(iso).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

export function formatAmount(cents) {
  if (cents == null) return '[amount unavailable]';
  return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

export function daysOut(iso) {
  return Math.round((new Date(iso) - Date.now()) / 86400000);
}

// 'extended_period' was "quarterly" until Sprint 21.2 confirmed PbP has no
// real recurring-quarterly product — see queries.js classifyRenewalPlanLength.
// Promotion ending (BK, 11/3/26): a prepaid promo does not renew on its own, so the ask is to sign up
// for a regular plan. The club's touch (14 to 6 days out) and Inside Sales' last call (5 days or less)
// are drafts; no price is quoted because the promo plan's own price is not the regular rate.
export const PROMO_HANDOFF_DAYS = 5;

export function buildScript(reminder) {
  const first = firstName(reminder.member_name);
  const date = formatDate(reminder.current_period_end_at);
  const amount = formatAmount(reminder.amount_cents);
  const isAnnual = reminder.plan_length === 'annual';

  if (reminder.touch_stage === '14_day') {
    return daysOut(reminder.current_period_end_at) > PROMO_HANDOFF_DAYS
      ? `Hi ${first}, your promotional membership ends on ${date}. To keep playing without a gap, we can move you to a regular monthly membership starting that day. Reply 1 and we'll set it up, or reply 2 if you'd like to talk about other options.`
      : `Hi ${first}, quick reminder: your promotional membership ends on ${date} and does not renew on its own. Reply 1 and I'll set you up on a regular monthly membership so you keep your access, or reply 2 if you have questions.`;
  }

  if (reminder.touch_stage === '45_day') {
    return isAnnual
      ? `Hi ${first}, your annual membership is set to renew on ${date} for ${amount}. As you likely know, annual plans provide the best value membership. Reply 1 to renew your plan, or reply 2 if you'd like to consider switching to monthly or cancelling.`
      : `Hi ${first}, your current membership period ends on ${date}, and after that you'll move to our standard monthly billing at ${amount}/month. Reply 1 to continue on monthly, or reply 2 if you'd like to consider switching to annual or cancelling.`;
  }
  return isAnnual
    ? `Hi ${first}, quick reminder — your membership renews in one week, on ${date}. Reply 1 to confirm, or reply 2 if you'd like to make changes. Note that cancelling after renewal is subject to a prorated refund and processing fee.`
    : `Hi ${first}, quick reminder — your membership moves to monthly billing in one week, on ${date}. Reply 1 to confirm, or reply 2 if you'd like to make changes.`;
}

